export const DEFAULT_SATSER = {
    engangstønad: [
        {
            fom: '01.01.2023',
            verdi: 92648,
        },
        {
            fom: '01.01.2021',
            verdi: 90300,
        },
        {
            fom: '01.01.2020',
            verdi: 84720,
        },
        {
            fom: '01.01.2019',
            verdi: 83140,
        },
        {
            fom: '01.01.2018',
            verdi: 63140,
        },
        {
            fom: '01.01.2017',
            verdi: 61120,
        },
        {
            fom: '01.01.2016',
            verdi: 46000,
        },
        {
            fom: '01.01.2015',
            verdi: 44190,
        },
        {
            fom: '01.01.2014',
            verdi: 38750,
        },
        {
            fom: '01.01.2010',
            verdi: 35263,
        },
    ],
    grunnbeløp: [
        {
            fom: '01.05.2026',
            verdi: 136549,
        },
        {
            fom: '01.05.2025',
            verdi: 130160,
        },
        {
            fom: '01.05.2024',
            verdi: 124028,
        },
        {
            fom: '01.05.2023',
            verdi: 118620,
        },
        {
            fom: '01.05.2022',
            verdi: 111477,
        },
        {
            fom: '01.05.2021',
            verdi: 106399,
        },
        {
            fom: '01.05.2020',
            verdi: 101351,
        },
        {
            fom: '01.05.2019',
            verdi: 99858,
        },
        {
            fom: '01.05.2018',
            verdi: 96883,
        },
        {
            fom: '01.05.2017',
            verdi: 93634,
        },
        {
            fom: '01.05.2016',
            verdi: 92576,
        },
        {
            fom: '01.05.2015',
            verdi: 90068,
        },
        {
            fom: '01.05.2014',
            verdi: 88370,
        },
        {
            fom: '01.05.2013',
            verdi: 85245,
        },
        {
            fom: '01.05.2012',
            verdi: 82122,
        },
        {
            fom: '01.05.2011',
            verdi: 79216,
        },
        {
            fom: '01.05.2010',
            verdi: 75641,
        },
        {
            fom: '01.05.2009',
            verdi: 72881,
        },
        {
            fom: '01.05.2008',
            verdi: 70256,
        },
        {
            fom: '01.05.2007',
            verdi: 66812,
        },
        {
            fom: '01.05.2006',
            verdi: 62892,
        },
        {
            fom: '01.05.2005',
            verdi: 60699,
        },
        {
            fom: '01.05.2004',
            verdi: 58778,
        },
        {
            fom: '01.05.2003',
            verdi: 56861,
        },
        {
            fom: '01.05.2002',
            verdi: 54170,
        },
        {
            fom: '01.05.2001',
            verdi: 51360,
        },
        {
            fom: '01.05.2000',
            verdi: 49090,
        },
        {
            fom: '01.05.1999',
            verdi: 46950,
        },
        {
            fom: '01.05.1998',
            verdi: 45370,
        },
        {
            fom: '01.05.1997',
            verdi: 42500,
        },
        {
            fom: '01.05.1996',
            verdi: 41000,
        },
        {
            fom: '01.05.1995',
            verdi: 39230,
        },
        {
            fom: '01.05.1994',
            verdi: 38080,
        },
        {
            fom: '01.05.1993',
            verdi: 37300,
        },
        {
            fom: '01.05.1992',
            verdi: 36500,
        },
        {
            fom: '01.05.1991',
            verdi: 35500,
        },
        {
            fom: '01.05.1990',
            verdi: 34000,
        },
        {
            fom: '01.12.1990',
            verdi: 34100,
        },
        {
            fom: '01.04.1989',
            verdi: 32700,
        },
        {
            fom: '01.01.1988',
            verdi: 30400,
        },
        {
            fom: '01.04.1988',
            verdi: 31000,
        },
        {
            fom: '01.05.1987',
            verdi: 29900,
        },
        {
            fom: '01.01.1986',
            verdi: 26300,
        },
        {
            fom: '01.05.1986',
            verdi: 28000,
        },
        {
            fom: '01.05.1985',
            verdi: 25900,
        },
        {
            fom: '01.05.1984',
            verdi: 24200,
        },
        {
            fom: '01.01.1983',
            verdi: 21800,
        },
        {
            fom: '01.05.1983',
            verdi: 22600,
        },
        {
            fom: '01.05.1982',
            verdi: 21200,
        },
        {
            fom: '01.01.1981',
            verdi: 17400,
        },
        {
            fom: '01.05.1981',
            verdi: 19100,
        },
        {
            fom: '01.10.1981',
            verdi: 19600,
        },
        {
            fom: '01.01.1980',
            verdi: 16100,
        },
        {
            fom: '01.05.1980',
            verdi: 16900,
        },
        {
            fom: '01.01.1979',
            verdi: 15200,
        },
        {
            fom: '01.07.1978',
            verdi: 14700,
        },
        {
            fom: '01.01.1977',
            verdi: 13100,
        },
        {
            fom: '01.05.1977',
            verdi: 13400,
        },
        {
            fom: '01.12.1977',
            verdi: 14400,
        },
        {
            fom: '01.01.1976',
            verdi: 11800,
        },
        {
            fom: '01.05.1976',
            verdi: 12100,
        },
        {
            fom: '01.01.1975',
            verdi: 10400,
        },
        {
            fom: '01.05.1975',
            verdi: 11000,
        },
        {
            fom: '01.01.1974',
            verdi: 9200,
        },
        {
            fom: '01.05.1974',
            verdi: 9700,
        },
        {
            fom: '01.01.1973',
            verdi: 8500,
        },
        {
            fom: '01.01.1972',
            verdi: 7900,
        },
        {
            fom: '01.01.1971',
            verdi: 7200,
        },
        {
            fom: '01.05.1971',
            verdi: 7500,
        },
        {
            fom: '01.01.1970',
            verdi: 6800,
        },
        {
            fom: '01.01.1969',
            verdi: 6400,
        },
        {
            fom: '01.01.1968',
            verdi: 5900,
        },
        {
            fom: '01.01.1967',
            verdi: 5400,
        },
    ],
};
